import useAuth from '../auth/useAuth';

export default function useSuperuser() {
  const { user, isLoading } = useAuth();
  const organizationId = user?.organization_id ?? null;
  const superuserOrganizationId = parseInt(process.env.REACT_APP_SUPERUSER_ORGANIZATION_ID, 10);

  return {
    isSuperuser: organizationId === null ? null : organizationId === superuserOrganizationId,
    isLoading,
    organizationId,
  };
}
